import React, { useState } from "react";

import Sheet from "components/sheet/Sheet";
import TextField from "components/form/textField/TextField";
import SelectNew from "components/select/SelectNew";
import Checkbox from "components/form/checkbox/Checkbox";
import { useTranslation } from "react-i18next";

type CustomerNoteModalNewProps = {
  isVisible: boolean;
  onClose: () => void;
  onOk: (newNote: string, highPriority: boolean) => void;
};

export default function CustomerNoteModalNew(props: CustomerNoteModalNewProps) {
  const [note, setNote] = useState<string>("");
  const [highPriority, setHighPriority] = useState<boolean>(false);
  const { t, i18n } = useTranslation();
  function handleOk() {
    props.onOk(note, highPriority);
    setNote("");
  }

  function handleClose() {
    setNote("");
    props.onClose();
  }

  return (
    <Sheet
      open={props.isVisible}
      size="small"
      height="flexible"
      closable
      title={t("Add Customer Note")}
      onOk={() => handleOk()}
      okDisabled={note.length < 2}
      cancelText={t("Cancel")}
      okText={t("Add Note")}
      onCancel={() => handleClose()}
      overflow
    >
      <div>
        <TextField
          label={t("Enter Note")}
          id="booking-modal-notes-input"
          rows={2}
          value={note}
          onChange={({ target }: { target: EventTarget & HTMLTextAreaElement }) => setNote(target.value)}
        ></TextField>
        <div className="mt-2">
          <Checkbox
            label={t("High Priority")}
            checked={highPriority}
            onChange={e => setHighPriority(e.target.checked)}
            size="medium"
            supportText={t("High priority notes will be displayed on the tee sheet check in page")}
          />
        </div>
      </div>
    </Sheet>
  );
}
